import { Plugins } from '@capacitor/core';
import { RHP } from 'providers';

const { Browser } = Plugins;

export function RankingCorporate(props) {
    // console.log('RankingCorporate', iframeReplace('https://ranking.openstartups.net'));
    // iframeReplace('https://ranking.openstartups.net', '/home')();
    Browser.open({ url: 'https://ranking.openstartups.net', toolbarColor: '#45aaf2' });
    RHP.goBack();
    return null;
}
export default RankingCorporate;
